export const monthsArray = [
    {
        value: '01'
    },
    {
        value: '02'
    },
    {
        value: '03'
    },
    {
        value: '04'
    },
    {
        value: '05'
    },
    {
        value: '06'
    },
    {
        value: '07'
    },
    {
        value: '08'
    },
    {
        value: '09'
    },
    {
        value: '10'
    },
    {
        value: '11'
    },
    {
        value: '12'
    }
];
